<template>
  <VueDraggable ref="templateRefDraggableElement">
    <slot />
  </VueDraggable>
</template>

<script lang="ts" setup>
import { VueDraggable } from "vue-draggable-plus";

defineSlots<{
  default: () => void;
}>();

const templateRefDraggableElement = useTemplateRef("templateRefDraggableElement");

defineExpose({
  element: templateRefDraggableElement,
});
</script>
